export enum LoginStatus {
  unauthorized = 'unauthorized',
  pending = 'pending',
  authenticating = 'authenticating',
  preparing = 'preparing',
  preparationError = 'preparationError',
  login = 'login',
  expired = 'expired',
  passwordExpired = 'passwordExpired',
  loggingOut = 'loggingOut',
}
